import React, {useEffect, useState} from "react";
import {Edit2} from "react-feather";
import API from "../../../utils/API";
import Loader from "../../../components/Loader";
import BordeloConnectForm from "./BordeloConnectForm";

const BordeloConnect = ({id}) => {

    const [edit,setEdit] = useState(false)
    const [data,setData] = useState(false)
    const [loaded, setLoaded] = useState(false)

    useEffect(()=>{
        API.get(`/admin/bordelo/publisherrcid/${id}`).then((response) => {
            setData(response.data.data)
            setLoaded(true)
        });
    },[edit])

    return (
        <>
            {loaded ?
                edit ?
                    <>
                        <div className="row">
                            <div className="col">
                                <BordeloConnectForm id={id} bordeloId={data.bordeloid} bordeloApiKey={data.bordeloapikey} close={() => setEdit(false)}/>
                            </div>
                            <div className="col-auto">
                                <button onClick={() => {setEdit(false)}} className="btn btn-outline-secondary mb-2">X</button>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="row">
                            <div className="col">
                                {data.bordeloid ?
                                    <>
                                        <div className="row">
                                            <div className="col-4">
                                                <strong>Bordelo Id</strong>
                                            </div>
                                            <div className="col">
                                                {data.bordeloid}
                                            </div>
                                        </div>
                                        {data.bordeloapikey &&
                                            <div className="row">
                                                <div className="col-4">
                                                    <strong>Bordelo API Key</strong>
                                                </div>
                                                <div className="col">
                                                    {data.bordeloapikey}
                                                </div>
                                            </div>
                                        }
                                    </>
                                    :
                                    <span className="text-primary">Not connected</span>
                                }
                            </div>
                            <div className="col-auto text-right">
                                <Edit2 onClick={() => {
                                    setEdit(true)
                                }} className="align-middle mr-1 cursor-pointer" size={18}/>
                            </div>
                        </div>
                    </>
                :
                <Loader/>
            }
        </>
    )
}

export default BordeloConnect
